var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.navItems),function(n,i){return _c('v-btn',{key:i,staticClass:"mr-5",attrs:{"color":"white"},on:{"click":function($event){return _vm.$router.push(n.path)}}},[_vm._v(" "+_vm._s(_vm.$t(n.meta.linkKey))+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }